import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  heading: 'your money is always safe',
  subHeading: '100% secure payments',
  markerUrls: ['https://assets.airtel.in/static-assets/airtel-pay-sdk/payment-options/xxhdpi/pci.png'],
  markerUrlSize: 'sm'
}, getTestId('TrustMarkerWidgetContainer'));